// Strings for the first-run introduction (lib/onboarding).
import { registerMessages } from '../i18n.svelte';

registerMessages({
  nl: {
    'onb.dialog': 'Welkom bij Timepeak',
    'onb.step_of': 'Stap {step} van {total}',
    'onb.later': 'Later',
    'onb.later_hint': 'Je kunt alles later aanpassen bij Instellingen.',
    'onb.skip': 'Overslaan',
    'onb.next': 'Volgende',
    'onb.back': 'Terug',
    'onb.saving': 'Opslaan…',
    'onb.start': 'Laten we beginnen',

    'onb.welcome.kicker': 'Welkom{name}',
    'onb.welcome.title': 'Klaar om je tijd te laten tellen?',
    'onb.welcome.text': 'In een paar korte stappen richten we Timepeak in zoals jij werkt. Duurt een minuutje, en alles is later nog aan te passen.',
    'onb.welcome.p1': 'Start en stop je timer overal: web, iPhone en Android lopen gelijk',
    'onb.welcome.p2': 'Zie per klant wat je verdient en wat er nog openstaat',
    'onb.welcome.p3': 'Exporteer je uren in seconden voor je factuur',

    'onb.work.kicker': 'Hoe je werkt',
    'onb.work.title': 'Jouw tarief en weergave',
    'onb.work.text': 'Je standaardtarief vullen we in bij nieuwe klanten en registraties.',
    'onb.work.rate': 'Standaard uurtarief',
    'onb.work.rate_hint': 'Excl. btw. Per klant kun je een ander tarief kiezen.',
    'onb.work.rate_required': 'Vul je uurtarief in, of sla deze stap over.',
    'onb.work.duration': 'Uren weergeven als',
    'onb.work.duration_hm': '7:30',
    'onb.work.duration_decimal': '7,50',
    'onb.work.duration_text': '7u 30m',
    'onb.work.theme': 'Thema',
    'onb.work.theme_light': 'Licht',
    'onb.work.theme_dark': 'Donker',
    'onb.work.theme_system': 'Systeem',
    'onb.work.quick': 'Snelle tijdinvoer',
    'onb.work.quick_text': 'Typ 930 of 9.30 en Timepeak maakt er 09:30 van.',

    'onb.week.kicker': 'Werkweek',
    'onb.week.title': 'Hoeveel wil je per week werken?',
    'onb.week.text': 'Hiermee laten we je voortgang zien op het dashboard en in je rapporten.',
    'onb.week.hours': 'Doel per week',
    'onb.week.hours_unit': 'uur',
    'onb.week.days': 'Werkdagen',
    'onb.week.per_day': 'Dat is gemiddeld {hours} per werkdag.',
    'onb.week.no_days': 'Kies minstens één werkdag.',
    'onb.week.start': 'Week begint op',

    'onb.period.kicker': 'Factuurperiode',
    'onb.period.title': 'Hoe vaak factureer je?',
    'onb.period.text': 'Timepeak toont per periode wat je hebt gewerkt en wat er nog gefactureerd moet worden.',
    'onb.period.weekly': 'Per week',
    'onb.period.weekly_text': 'Elke week een overzicht',
    'onb.period.monthly': 'Per maand',
    'onb.period.monthly_text': 'Het meest gekozen',
    'onb.period.quarterly': 'Per kwartaal',
    'onb.period.quarterly_text': 'Elke drie maanden',
    'onb.period.custom': 'Eigen ritme',
    'onb.period.custom_text': 'Bijv. elke 2 weken',
    'onb.period.every': 'Elke',
    'onb.period.unit_weeks': 'weken',
    'onb.period.unit_months': 'maanden',
    'onb.period.from': 'Vanaf',
    'onb.period.current': 'Je huidige periode: {range}',

    'onb.round.kicker': 'Afronden',
    'onb.round.title': 'Wil je je tijd afronden?',
    'onb.round.text': 'Veel freelancers ronden af op kwartieren. Je originele tijd blijft altijd bewaard.',
    'onb.round.enable': 'Tijd afronden',
    'onb.round.enable_text': 'Per registratie, standaard voor al je klanten.',
    'onb.round.mode': 'Richting',
    'onb.round.nearest': 'Dichtstbij',
    'onb.round.up': 'Omhoog',
    'onb.round.down': 'Omlaag',
    'onb.round.increment': 'Afronden op',
    'onb.round.minutes': '{count} min',
    'onb.round.example': 'Voorbeeld',
    'onb.round.becomes': 'wordt',
    'onb.round.off': 'Geen afronding: je factureert precies de tijd die je werkt.',

    'onb.client.kicker': 'Eerste klant',
    'onb.client.title': 'Voor wie werk je?',
    'onb.client.text': 'Voeg je eerste klant toe, dan kun je meteen een timer starten.',
    'onb.client.name': 'Naam van de klant',
    'onb.client.name_placeholder': 'Bijv. Studio Noord',
    'onb.client.email': 'E-mail',
    'onb.client.email_placeholder': 'factuur@klant.nl',
    'onb.client.rate': 'Uurtarief',
    'onb.client.color': 'Kleur',
    'onb.client.activities': 'Wat doe je voor deze klant?',
    'onb.client.activities_hint': 'Kies activiteiten of voeg je eigen toe.',
    'onb.client.custom': 'Eigen activiteit',
    'onb.client.custom_placeholder': 'Bijv. Copywriting',
    'onb.client.add': 'Toevoegen',
    'onb.client.created': '{name} is toegevoegd',
    'onb.client.created_text': 'Met {count} activiteiten. Je vindt de klant bij Klanten.',
    'onb.client.created_text.one': 'Met 1 activiteit. Je vindt de klant bij Klanten.',
    'onb.client.existing': 'Je hebt al {count} klanten. Je kunt deze stap ook overslaan.',
    'onb.client.existing.one': 'Je hebt al 1 klant. Je kunt deze stap ook overslaan.',
    'onb.client.name_required': 'Vul een naam in of sla deze stap over.',
    'onb.client.email_invalid': 'Dit lijkt geen geldig e-mailadres.',
    'onb.act.development': 'Development',
    'onb.act.design': 'Design',
    'onb.act.meeting': 'Meeting',
    'onb.act.consultancy': 'Consultancy',
    'onb.act.projectmanagement': 'Projectmanagement',
    'onb.act.research': 'Research',
    'onb.act.testing': 'Testing',
    'onb.act.support': 'Support',

    'onb.notif.kicker': 'Meldingen',
    'onb.notif.title': 'Nooit meer een timer vergeten',
    'onb.notif.text': 'Timepeak kan je een seintje geven als je timer al lang loopt of als je pauze uitloopt. Je kiest zelf wat je wilt ontvangen.',
    'onb.notif.device': 'Pushmeldingen op dit apparaat',
    'onb.notif.enable': 'Meldingen inschakelen',
    'onb.notif.enabled': 'Meldingen staan aan op dit apparaat',
    'onb.notif.denied': 'Je browser blokkeert meldingen voor Timepeak. Sta ze toe via het slotje in de adresbalk.',
    'onb.notif.unsupported': 'Deze browser ondersteunt geen pushmeldingen. Op je telefoon werken ze wel via de Timepeak-app.',
    'onb.notif.failed': 'Meldingen konden niet worden ingeschakeld. Probeer het later via Instellingen.',
    'onb.notif.long_timer': 'Herinnering als je timer lang loopt',
    'onb.notif.long_timer_text': 'Na {hours} uur',
    'onb.notif.long_break': 'Herinnering als je pauze uitloopt',
    'onb.notif.long_break_text': 'Na {minutes} minuten',
    'onb.notif.daily': 'Dagoverzicht',
    'onb.notif.daily_text': 'Elke werkdag om {time}',
    'onb.notif.quiet': 'Stille uren: {from}–{to}, dan sturen we niets.',
    'onb.notif.settings': 'Alle meldingen instellen',

    'onb.done.kicker': 'Klaar!',
    'onb.done.title': 'Alles staat klaar',
    'onb.done.text': 'Je bent helemaal ingericht. Start je eerste timer en zie je uren meteen meetellen.',
    'onb.done.timer': 'Start je eerste timer',
    'onb.done.dashboard': 'Naar het dashboard',
    'onb.done.sum_rate': 'Standaardtarief {rate}',
    'onb.done.sum_week': '{hours} uur per week, {days} dagen',
    'onb.done.sum_period': 'Factureren {period}',
    'onb.done.sum_round': 'Afronden op {minutes} min',
    'onb.done.sum_client': 'Eerste klant: {name}',
    'onb.done.sum_notif': 'Meldingen aan',
    'onb.done.tip': 'Tip: druk op ⌘K om overal snel naartoe te gaan.',
    'onb.period_word.weekly': 'per week',
    'onb.period_word.monthly': 'per maand',
    'onb.period_word.quarterly': 'per kwartaal',
    'onb.period_word.custom': 'in je eigen ritme',

    'onb.day.0': 'Zo',
    'onb.day.1': 'Ma',
    'onb.day.2': 'Di',
    'onb.day.3': 'Wo',
    'onb.day.4': 'Do',
    'onb.day.5': 'Vr',
    'onb.day.6': 'Za',
    'onb.day_long.0': 'zondag',
    'onb.day_long.1': 'maandag',
    'onb.day_long.2': 'dinsdag',
    'onb.day_long.3': 'woensdag',
    'onb.day_long.4': 'donderdag',
    'onb.day_long.5': 'vrijdag',
    'onb.day_long.6': 'zaterdag'
  },
  en: {
    'onb.dialog': 'Welcome to Timepeak',
    'onb.step_of': 'Step {step} of {total}',
    'onb.later': 'Later',
    'onb.later_hint': 'You can change everything later in Settings.',
    'onb.skip': 'Skip',
    'onb.next': 'Next',
    'onb.back': 'Back',
    'onb.saving': 'Saving…',
    'onb.start': "Let's get started",

    'onb.welcome.kicker': 'Welcome{name}',
    'onb.welcome.title': 'Ready to make your time count?',
    'onb.welcome.text': 'In a few short steps we set Timepeak up the way you work. It takes about a minute, and you can change everything later.',
    'onb.welcome.p1': 'Start and stop your timer anywhere: web, iPhone and Android stay in sync',
    'onb.welcome.p2': 'See per client what you earn and what is still outstanding',
    'onb.welcome.p3': 'Export your hours in seconds for your invoice',

    'onb.work.kicker': 'How you work',
    'onb.work.title': 'Your rate and display',
    'onb.work.text': 'We use your default rate for new clients and entries.',
    'onb.work.rate': 'Default hourly rate',
    'onb.work.rate_hint': 'Excl. VAT. You can set a different rate per client.',
    'onb.work.rate_required': 'Enter your hourly rate, or skip this step.',
    'onb.work.duration': 'Show hours as',
    'onb.work.duration_hm': '7:30',
    'onb.work.duration_decimal': '7.50',
    'onb.work.duration_text': '7h 30m',
    'onb.work.theme': 'Theme',
    'onb.work.theme_light': 'Light',
    'onb.work.theme_dark': 'Dark',
    'onb.work.theme_system': 'System',
    'onb.work.quick': 'Quick time input',
    'onb.work.quick_text': 'Type 930 or 9.30 and Timepeak turns it into 09:30.',

    'onb.week.kicker': 'Work week',
    'onb.week.title': 'How much do you want to work per week?',
    'onb.week.text': 'We use this to show your progress on the dashboard and in your reports.',
    'onb.week.hours': 'Weekly target',
    'onb.week.hours_unit': 'hours',
    'onb.week.days': 'Work days',
    'onb.week.per_day': 'That is {hours} per work day on average.',
    'onb.week.no_days': 'Pick at least one work day.',
    'onb.week.start': 'Week starts on',

    'onb.period.kicker': 'Billing period',
    'onb.period.title': 'How often do you invoice?',
    'onb.period.text': 'Timepeak shows per period what you worked and what still needs to be invoiced.',
    'onb.period.weekly': 'Weekly',
    'onb.period.weekly_text': 'An overview every week',
    'onb.period.monthly': 'Monthly',
    'onb.period.monthly_text': 'The most popular choice',
    'onb.period.quarterly': 'Quarterly',
    'onb.period.quarterly_text': 'Every three months',
    'onb.period.custom': 'Custom rhythm',
    'onb.period.custom_text': 'E.g. every 2 weeks',
    'onb.period.every': 'Every',
    'onb.period.unit_weeks': 'weeks',
    'onb.period.unit_months': 'months',
    'onb.period.from': 'Starting',
    'onb.period.current': 'Your current period: {range}',

    'onb.round.kicker': 'Rounding',
    'onb.round.title': 'Do you want to round your time?',
    'onb.round.text': 'Many freelancers round to quarter hours. Your original time is always kept.',
    'onb.round.enable': 'Round time',
    'onb.round.enable_text': 'Per entry, the default for all your clients.',
    'onb.round.mode': 'Direction',
    'onb.round.nearest': 'Nearest',
    'onb.round.up': 'Up',
    'onb.round.down': 'Down',
    'onb.round.increment': 'Round to',
    'onb.round.minutes': '{count} min',
    'onb.round.example': 'Example',
    'onb.round.becomes': 'becomes',
    'onb.round.off': 'No rounding: you bill exactly the time you work.',

    'onb.client.kicker': 'First client',
    'onb.client.title': 'Who do you work for?',
    'onb.client.text': 'Add your first client so you can start a timer right away.',
    'onb.client.name': 'Client name',
    'onb.client.name_placeholder': 'E.g. Studio North',
    'onb.client.email': 'E-mail',
    'onb.client.email_placeholder': 'billing@client.com',
    'onb.client.rate': 'Hourly rate',
    'onb.client.color': 'Colour',
    'onb.client.activities': 'What do you do for this client?',
    'onb.client.activities_hint': 'Pick activities or add your own.',
    'onb.client.custom': 'Custom activity',
    'onb.client.custom_placeholder': 'E.g. Copywriting',
    'onb.client.add': 'Add',
    'onb.client.created': '{name} has been added',
    'onb.client.created_text': 'With {count} activities. You will find the client under Clients.',
    'onb.client.created_text.one': 'With 1 activity. You will find the client under Clients.',
    'onb.client.existing': 'You already have {count} clients. You can also skip this step.',
    'onb.client.existing.one': 'You already have 1 client. You can also skip this step.',
    'onb.client.name_required': 'Enter a name or skip this step.',
    'onb.client.email_invalid': 'This does not look like a valid e-mail address.',
    'onb.act.development': 'Development',
    'onb.act.design': 'Design',
    'onb.act.meeting': 'Meeting',
    'onb.act.consultancy': 'Consultancy',
    'onb.act.projectmanagement': 'Project management',
    'onb.act.research': 'Research',
    'onb.act.testing': 'Testing',
    'onb.act.support': 'Support',

    'onb.notif.kicker': 'Notifications',
    'onb.notif.title': 'Never forget a timer again',
    'onb.notif.text': 'Timepeak can nudge you when your timer has been running for a long time or your break runs over. You choose what you receive.',
    'onb.notif.device': 'Push notifications on this device',
    'onb.notif.enable': 'Turn on notifications',
    'onb.notif.enabled': 'Notifications are on for this device',
    'onb.notif.denied': 'Your browser blocks notifications for Timepeak. Allow them via the lock icon in the address bar.',
    'onb.notif.unsupported': 'This browser does not support push notifications. On your phone they work through the Timepeak app.',
    'onb.notif.failed': 'Notifications could not be turned on. Try again later in Settings.',
    'onb.notif.long_timer': 'Reminder when your timer runs long',
    'onb.notif.long_timer_text': 'After {hours} hours',
    'onb.notif.long_break': 'Reminder when your break runs over',
    'onb.notif.long_break_text': 'After {minutes} minutes',
    'onb.notif.daily': 'Daily summary',
    'onb.notif.daily_text': 'Every work day at {time}',
    'onb.notif.quiet': 'Quiet hours: {from}–{to}, we send nothing then.',
    'onb.notif.settings': 'All notification settings',

    'onb.done.kicker': 'Done!',
    'onb.done.title': 'You are all set',
    'onb.done.text': 'Everything is set up. Start your first timer and watch your hours add up.',
    'onb.done.timer': 'Start your first timer',
    'onb.done.dashboard': 'Go to the dashboard',
    'onb.done.sum_rate': 'Default rate {rate}',
    'onb.done.sum_week': '{hours} hours per week, {days} days',
    'onb.done.sum_period': 'Invoicing {period}',
    'onb.done.sum_round': 'Rounding to {minutes} min',
    'onb.done.sum_client': 'First client: {name}',
    'onb.done.sum_notif': 'Notifications on',
    'onb.done.tip': 'Tip: press ⌘K to jump anywhere quickly.',
    'onb.period_word.weekly': 'weekly',
    'onb.period_word.monthly': 'monthly',
    'onb.period_word.quarterly': 'quarterly',
    'onb.period_word.custom': 'in your own rhythm',

    'onb.day.0': 'Sun',
    'onb.day.1': 'Mon',
    'onb.day.2': 'Tue',
    'onb.day.3': 'Wed',
    'onb.day.4': 'Thu',
    'onb.day.5': 'Fri',
    'onb.day.6': 'Sat',
    'onb.day_long.0': 'Sunday',
    'onb.day_long.1': 'Monday',
    'onb.day_long.2': 'Tuesday',
    'onb.day_long.3': 'Wednesday',
    'onb.day_long.4': 'Thursday',
    'onb.day_long.5': 'Friday',
    'onb.day_long.6': 'Saturday'
  }
});
